export default __webpack_public_path__ + "static/gurupurnima-fe7728f3ac34ee6816725029a5b15ef9.jpg";